import { MARQUEE_ITEMS } from "../data/cv";
import { useLang, MARQUEE_HI } from "../i18n";

const Marquee = ({ dark = false }) => {
  const { lang } = useLang();
  const base = lang === "hi" ? MARQUEE_HI : MARQUEE_ITEMS;
  const items = [...base, ...base];
  return (
    <div
      className={`relative overflow-hidden py-5 border-y ${dark ? "bg-void border-bone/10 text-bone" : "bg-ink text-bone border-bone/20"}`}
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-lg sm:text-2xl px-6">{item}</span>
            <span className="text-saffron text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
